import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'

type Language = 'jp' | 'en' | 'ko'

interface LanguageState {
  language: Language
}

const initialState: LanguageState = {
  language: 'jp',
}

// Slice
const LanguageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      const { payload } = action
      state.language = payload
    },
  },
})

// Selectors
export const getLanguageSelector = (state: RootState): Language =>
  state.language.language

// Actions
export const { setLanguage } = LanguageSlice.actions

// Reducers
export default LanguageSlice.reducer
